import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { graphql, readInlineData } from "react-relay";

import { EntityLink } from "scmp-app/components/entity-link";
import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { currentArticleAtom } from "scmp-app/lib/current-item";
import type { sectionHeaderFeaturesArticle$key } from "scmp-app/queries/__generated__/sectionHeaderFeaturesArticle.graphql";

import { Container } from "./styles";

export type HeaderFeaturesSectionProps = HeaderFeatureCommonProps & {
  isMagazineStyle?: boolean;
  size?: sectionNameSize;
};

export type sectionNameSize = "large" | "small";

export const HeaderFeaturesSection: FunctionComponent<HeaderFeaturesSectionProps> = ({
  isMagazineStyle = false,
  size = "small",
  ...props
}) => {
  const currentArticle = useAtomValue(currentArticleAtom);
  if (!currentArticle) return null;

  const data = readInlineData<sectionHeaderFeaturesArticle$key>(
    graphql`
      fragment sectionHeaderFeaturesArticle on Article @inline {
        sections {
          value {
            name
            published
            ...entityLink
          }
        }
      }
    `,
    currentArticle,
  );

  const sectionPath = data?.sections?.[0]?.value;
  if (!sectionPath || sectionPath.length === 0) return null;

  const targetSection = sectionPath.toReversed().find(section => section?.published === true);

  if (!targetSection) return null;

  const displayName = targetSection.name ?? null;

  return (
    <Container $isMagazineStyle={isMagazineStyle} $size={size} {...getResponsiveProps(props)}>
      <EntityLink reference={targetSection}>{displayName}</EntityLink>
    </Container>
  );
};

HeaderFeaturesSection.displayName = "HeaderFeaturesSection";
